import View from '@play-co/timestep-core/lib/ui/View';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import uiConfig from 'src/lib/ui/config';
import { ImageSliceView } from '@play-co/timestep-core/ui';
import PopupBasic from 'src/game/components/popups/PopupBasic';
import sounds from 'src/lib/sounds';
import { isPlatformNative } from 'src/lib/native/native.util';
import { startLogoutSequence } from 'src/game/native/native.sequence';
import { openLineSettings } from 'src/lib/platformUtils';
import { showSupportWidget } from 'src/lib/CSWidget';
import { withLoading } from 'src/lib/utils';
import { Feature } from 'src/replicant/analytics';
import { track } from 'src/lib/analytics/utils';

import { AssetGroup } from '@play-co/timestep-core';

const getNativeHeightOffset = () => (isPlatformNative() ? 100 : 0);

export default class PopupFaq extends PopupBasic {
  constructor(creationOpts: { superview: View; close: () => void }) {
    super({
      ...creationOpts,
      width: 591,
      height: 1070 + getNativeHeightOffset(),
      zIndex: 10005,
      skipMessage: true,
      darkerBg: true,
      tracking: { feature: 'faq', $subFeature: 'popup-faq' },
    });

    const fontSize = 18;

    const q1 = this.box.addSubview(
      new ImageSliceView({
        x: 40,
        y: 80,
        width: this.box.style.width - 80,
        height: 50,
        image: 'assets/ui/popups/panel_underline.png',
        slices: {
          top: 2,
          bot: 2,
          left: 2,
          right: 2,
        },
      }),
    );
    q1.addSubview(
      new LangBitmapFontTextView({
        width: q1.style.width,
        height: q1.style.height,
        align: 'left',
        verticalAlign: 'center',
        size: fontSize,
        color: '#9C490D',
        wordWrap: true,
        font: 'Body',
        isRichText: true,
        localeText: () => i18n('faq.body.q1'),
      }),
    );

    this.box.addSubview(
      new LangBitmapFontTextView({
        x: 40,
        y: 150,
        width: this.box.style.width - 80,
        align: 'left',
        verticalAlign: 'center',
        size: fontSize,
        color: '#9C490D',
        wordWrap: true,
        font: 'Body',
        isRichText: true,
        localeText: () => i18n('faq.body.a1'),
      }),
    );

    const q2 = this.box.addSubview(
      new ImageSliceView({
        x: 40,
        y: 350,
        width: this.box.style.width - 80,
        height: 50,
        image: 'assets/ui/popups/panel_underline.png',
        slices: {
          top: 2,
          bot: 2,
          left: 2,
          right: 2,
        },
      }),
    );
    q2.addSubview(
      new LangBitmapFontTextView({
        width: q2.style.width,
        height: q2.style.height,
        align: 'left',
        verticalAlign: 'center',
        size: fontSize,
        color: '#9C490D',
        wordWrap: true,
        font: 'Body',
        isRichText: true,
        localeText: () => i18n('faq.body.q2'),
      }),
    );
    this.box.addSubview(
      new LangBitmapFontTextView({
        x: 40,
        y: 420,
        width: this.box.style.width - 80,
        align: 'left',
        verticalAlign: 'center',
        size: fontSize,
        color: '#9C490D',
        wordWrap: true,
        font: 'Body',
        isRichText: true,
        localeText: () => i18n('faq.body.a2'),
      }),
    );

    let y = this.box.style.height - 395 - getNativeHeightOffset();

    new ButtonScaleViewWithText({
      ...uiConfig.buttons.secondary,
      superview: this.box,
      x: this.box.style.width * 0.5,
      y,
      labelOffsetY: -1,
      fontSize: 28,
      font: 'Body',
      height: 75,
      width: 460,
      centerOnOrigin: true,
      onClick: async () => {
        sounds.sfx.play('ok');
        track('CSWidgetLINESettings', {});
        openLineSettings();
      },
      localeText: () => i18n('error.support.openLINESettings'),
      tracking: { feature: 'faq', $subFeature: 'popup-faq-line-settings' },
    });

    const localeText = () => i18n('error.support.contactSupport');
    const onClick = async () => {
      sounds.sfx.play('ok');

      await withLoading(() => showSupportWidget(), {
        feature: Feature.FAQ._,
        subFeature: Feature.FAQ.SHOW_SUPPORT_WIDGET,
      });
    };

    y += 90;
    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...uiConfig.buttons.secondary,
        x: this.box.style.width * 0.5,
        y,
        labelOffsetY: -1,
        fontSize: 28,
        font: 'Body',
        height: 75,
        width: 300,
        centerOnOrigin: true,
        onClick,
        localeText,
        tracking: { feature: 'faq', $subFeature: 'popup-faq-contact-support' },
      }),
    );

    y += 60;
    this.box.addSubview(
      new LangBitmapFontTextView({
        x: this.box.style.width * 0.5,
        y,
        width: this.box.style.width - 80,
        align: 'center',
        verticalAlign: 'center',
        size: 22,
        color: '#3C73A2',
        font: 'Body',
        centerOnOrigin: true,
        localeText: () => i18n('error.support.supportHint'),
      }),
    );

    y += 90;
    if (isPlatformNative()) {
      this.box.addSubview(
        new ButtonScaleViewWithText({
          ...uiConfig.buttons.primary,
          x: this.box.style.width * 0.5,
          y,
          labelOffsetY: -1,
          fontSize: 28,
          font: 'Body',
          height: 75,
          width: 300,
          centerOnOrigin: true,
          localeText: () => i18n('native.logout.cta'),
          onClick: async () => startLogoutSequence(),
          tracking: { feature: 'faq', $subFeature: 'faq-popup-logout' },
        }),
      );
      y += getNativeHeightOffset();
    }

    this.buttonClose.removeFromSuperview();
    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...uiConfig.buttons.cancel,
        fontSize: 40,
        labelOffsetY: -2,
        font: 'Body',
        width: 235,
        height: 90,
        x: this.box.style.width / 2,
        y,
        centerOnOrigin: true,
        localeText: () => i18n('basic.back'),
        onClick: async () => {
          sounds.sfx.play('cancel');
          track('CSWidgetClose', {});
          return creationOpts.close();
        },
        tracking: { feature: 'settings', $subFeature: 'popup-faq-back' },
      }),
    );
  }

  protected getAssetsGroup() {
    return new AssetGroup(['assets/ui/popups/panel_underline.png']);
  }

  public init(opts: {}) {
    super.init(opts);
    this.title.setText(() => i18n('faq.title'));
  }
}
